import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadInspectors = (context, customerId) => new Promise((resolve, reject) => {
  Api.customerService.getInspectors(customerId)
    .then(response => {
      context.commit('setInspectors', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setInspectors', {});
      Http.setGlobalError(context, Http.createError(error, 'inspectors.actions.loadInspectors', { customerId }));
      reject();
    });
});

const addRating = (context, data) => new Promise((resolve, reject) => {
  const httpUnprocessableEntity = 422;
  Api.inspectorService.putRating(data.inspectorId, data)
    .then(response => {
      context.commit('setRating', response.data);
      resolve(response.data);
    })
    .catch(error => {
      if (error.status === httpUnprocessableEntity) {
        reject(error.data);
      } else {
        Http.setGlobalError(context, Http.createError(error, 'inspectors.actions.addRating', data));
        reject();
      }
    });
});

const loadRating = (context, data) => new Promise((resolve, reject) => {
  Api.inspectorService.getRating(data.inspectorId, data.customerId)
    .then(response => {
      context.commit('setRating', response.data);
      resolve(response.data);
    })
    .catch(error => {
      Http.setGlobalError(context, Http.createError(error, 'inspectors.actions.loadRating', data));
      reject();
    });
});

const getInspectorById = (context, inspectorId) => new Promise((resolve, reject) => {
  if (context.state.inspectors.length > 0) {
    const foundInspector = context.state.inspectors
      .find(inspector => inspector.id === Number(inspectorId));
    resolve(foundInspector);
  }

  Api.personService.getInspector(inspectorId)
    .then(response => resolve(response.data))
    .catch(() => reject());
});

export default {
  addRating,
  getInspectorById,
  loadInspectors,
  loadRating,
};
